/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Add_ButtonInputs */

const en_admin_footer_badges_add_button = /** @type {(inputs: Admin_Footer_Badges_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to footer`)
};

/**
* | output |
* | --- |
* | "Add to footer" |
*
* @param {Admin_Footer_Badges_Add_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_add_button = /** @type {((inputs?: Admin_Footer_Badges_Add_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Add_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_add_button(inputs)
});
export { admin_footer_badges_add_button as "admin.footer_badges.add_button" }